import React from 'react';

import { Select as MUISelect, TextField, Checkbox, OutlinedInput, FormControlLabel, Typography, createStyles, Theme, withStyles, RadioGroup, Radio } from '@material-ui/core';

import { RadioButtonUnchecked, RadioButtonChecked, Info } from '@material-ui/icons';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

import styles from '../readyForCarriageCheck.module.css';
import commonStyles from '../../common/common.module.css';
import GhaPickupStatusAwb from '../../../models/GhaPickupStatusAwb';
import { InterlineCarrier, InterlineChecks } from '../../../models/InterlineChecks';
import { OtherChecksForm } from '../../../models/OtherChecksForm';
import OtherChecksFormValue from '../../../models/OtherChecksFormValue';
import Select from 'react-select';

const materialStyles = (theme: Theme) =>
  createStyles({
    label: {
      color: 'var(--primaryblue)',
      fontSize: '13px',
      minWidth: '30px'
    },
    transferText: {
      width: '100%'
    },
    selectcss:{
      '& .css-yk16xz-control, & .css-1pahdxg-control, & .css-1fhf3k1-control':{
        borderColor: 'inherit',
        borderRadius: 'var(--ip-br)',
        fontSize: '12px',
        minHeight: '31px !important',
        boxShadow: 'none',
        '&:hover':{
          border: '1px solid var(--primaryblue)',
        }
      },
      '& .css-tlfecz-indicatorContainer, & .css-1gtu0rj-indicatorContainer': {
        padding: '0 4px' 
      },
      '& .css-1okebmr-indicatorSeparator, & .css-109onse-indicatorSeparator':{
        display: 'none'
      },
      '& .css-26l3qy-menu':{
        fontSize: '12px',
        '& > div': {
          height: '200px',
        }
      }
    },
    width40: {
      width: '39%',
      paddingRight: '20px'
    },
    radioGroup: {
      minWidth: '200px',
    },
    radioWrapper: {
      flex: '55%'
    },
    mtNeg12: {
      marginTop: '-12px'
    },
    fOne: {
      flex: '1 1 250px'
    }
  });

interface InterlineChecksProps {
  classes: any;
  interlineChecks: InterlineChecks;
  awbCode: string;
  carrierNumber: InterlineCarrier;
  poAwb: GhaPickupStatusAwb;
  deliveredDate: string;
  handleSetCarrier: (event: any) => void;
  handleSetNumber: (event: any) => void;
  handleSelectChange: (event: any) => void;
  checkElement: (check: boolean) => JSX.Element;
  onlyRead?: boolean;
  carrierList: Array<string>;
  securityNote: string;
  handleChangeNumber: (event: any) => void;
};

const transferProgram: Array<string> = [
  'AOSSP',
  'FACAOSSP',
  'MSP',
  'ACISP'
];

interface Option {
  value: string;
  label: string;
};


const interlineChecks = (props: InterlineChecksProps) => {
  const carrierOptions: Array<Option> = props.carrierList.map((item: any) => (
    {
      value: item.name,
      label: item.name
    }
  ));

  const checksForm: Array<JSX.Element> = transferProgram.map((item: string, index: number) => (
    <FormControlLabel
      control={
        <Checkbox
          color="primary"
          name=''
          value={ item }
          disabled
          icon={ <CheckBoxOutlineBlankIcon /> }
          id={ `${index}` }
          checkedIcon={ <CheckBoxIcon /> }
          classes={{
            root: props.classes.checkbox,
          }}
          checked={ props.carrierNumber.transfer_programs[index] === item.toLocaleLowerCase() }
        />
      }
      label={ item }
      className={ props.classes.completeLabel }
      key={ index }
    />
  ));

  const otherChecksForm: Array<JSX.Element> = props.interlineChecks.interline_form.map((item: OtherChecksForm, index: number) => {

    let infoText: string | null = null;
    if (item.info_url) {
      if (typeof (item.info_url) === 'string') {
        infoText = item.info_url;
      } else if (item.info_url[props.awbCode]) {
        infoText = item.info_url[props.awbCode];
      } else if (item.info_url['default']) {
        infoText = item.info_url['default'];
      }
    }
    const info: JSX.Element | null = infoText ?
      <Info color="primary" className={props.classes.materialIcon} onClick={() => window.open(infoText as string, '_blank')} />
      : null;


    const selectOptions: Array<JSX.Element> = item.values.map((opt: OtherChecksFormValue, ind: number) => {

      return (
        <FormControlLabel 
          value={ opt.value }
          id={`${ ind }`}
          key={ ind }
          disabled={ (props.onlyRead) || (props.deliveredDate !== null) }
          control={
            <Radio 
              color="primary" 
              icon={ <RadioButtonUnchecked fontSize="small" /> } 
              checkedIcon={ <RadioButtonChecked fontSize="small" color="primary" /> }
              id={`${ index }`}
            /> 
          } 
          label={<Typography className={props.classes.label}> { opt.value }</Typography>}
          classes={{
            root: props.classes.radio 
          }}
          className={ props.classes.radioScale }
        />
      )
    });

    const flag: JSX.Element = props.checkElement(props.interlineChecks.interline_form_data.interline_form_green[index]);

    return (
      <div key={ index } className={ `${ styles.wrapperForm }` }>

        <div className={ `${ styles.elementsWrapperInfo } ${ props.classes.width40 }` }>

          <div className={ [styles.name, props.classes.name].join(" ") }>{ item.name }</div>

          <div>{ info }</div>

        </div>

        <div className={ `${ commonStyles.dFlex } ${ styles.radioWrapper } ${ props.classes.radioWrapper }` }>

          <RadioGroup
            aria-label=""
            name=""
            row={ true }
            onChange={ props.handleSelectChange }
            value={ props.interlineChecks.interline_form_data.interline_form_data[index] }
            id={`${ index }`}
            className={ props.classes.radioGroup }
          >

          { selectOptions }

          </RadioGroup>

          <div className={ `${ styles.check } ${ commonStyles.mlauto } ${commonStyles.mr0}` }>{ flag }</div>

        </div>

      </div>
    )
  });

  return (
    <div className= { `${ commonStyles.wrapper } ${ styles.height200 } ${ commonStyles.tabBr }` }>

      <div>

        <div className={ styles.elementsWrapper }>

          <div className={ props.classes.mtNeg12 }>

            <FormControlLabel
              value="iac"
              control={
                <Checkbox
                  checked={ true }
                  icon={ <RadioButtonUnchecked fontSize="small" /> }
                  checkedIcon={ <RadioButtonChecked fontSize="small" color="primary" /> }
                  disabled={ props.onlyRead || props.deliveredDate !== null }
                />
              }
              label={ <Typography className={ props.classes.label }> Interline Transfer</Typography>}
            />

          </div>

        </div>

        <div className={ `${ commonStyles.fSpaceBtw } ${ commonStyles.flexWrap } ${ commonStyles.gap20 }`}>


          <div className= { `${ props.classes.selectcss } ${ props.classes.fOne }` } >

            <label className={ commonStyles.inputLabel }>Transferring Carrier</label>
            <Select
              className={ props.classes.select }
              options={ carrierOptions }
              value={ props.carrierNumber.carrier }
              onChange={ (event: any) => props.handleSetCarrier(event) }
              placeholder='Enter Transferring Carrier'
              error={ props.carrierNumber.carrier !== '' }
              isDisabled={ (props.onlyRead) || (props.deliveredDate !== null) }
            />

          </div>

          <div>
            <label className={ `${ commonStyles.inputLabel } ${ commonStyles.radioLabel }` }>Approved Transfer Program</label>
            <div className={ styles.textFieldWrapper }>

              { checksForm }

            </div>
          </div>


        </div>
        
        <div className={`${ styles.wrapper } ${commonStyles.mt4}`}>

          { otherChecksForm }

        </div>


      </div>
      <div className={`${commonStyles.inputLabelWrapper} ${commonStyles.mt4}`}>

        <label className={ commonStyles.inputLabel }>Security Notes</label>
        <TextField
          id="securityNote"
          value={ props.securityNote }
          variant="outlined"
          onChange={ props.handleChangeNumber }
          onBlur={ props.handleSetNumber }
          disabled={ (props.onlyRead || props.deliveredDate !== null) }
          inputProps={ { style: { padding: '6px 12px', width: '100%', fontSize: '13px' } } }
          InputLabelProps={ {
            className: props.classes.labelTransform
          } }
        />
      </div>

    </div>
  );
}

export default withStyles(materialStyles)(interlineChecks);